import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { css, cx } from '@wp-g2/styles';
import { noop } from '@wp-g2/utils';
import React from 'react';
import { CloseButton } from '../CloseButton';
import * as styles from './Alert.styles';
var CloseButtonWrapper = styles.CloseButtonWrapper;

function AlertCloseButton(_ref) {
  var className = _ref.className,
      isDismissable = _ref.isDismissable,
      _ref$onDismiss = _ref.onDismiss,
      onDismiss = _ref$onDismiss === void 0 ? noop : _ref$onDismiss,
      status = _ref.status,
      props = _objectWithoutProperties(_ref, ["className", "isDismissable", "onDismiss", "status"]);

  if (!isDismissable) return null;
  var classes = cx(css({
    color: styles.getTextColor(status)
  }), className);
  return /*#__PURE__*/React.createElement(CloseButtonWrapper, Object.assign({}, props, {
    className: classes
  }), /*#__PURE__*/React.createElement(CloseButton, {
    currentColor: true,
    iconSize: 16,
    onClick: onDismiss,
    title: "Dismiss"
  }));
}

export default /*#__PURE__*/React.memo(AlertCloseButton);